function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function SearchIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M11 15.1021C9.30566 15.1021 7.84827 14.069 7.22345 12.6H14.7766C14.1517 14.069 12.6943 15.1021 11 15.1021Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11C20 13.1216 19.2577 15.0706 18.025 16.6109L22.207 20.793L20.793 22.207L16.6109 18.025C15.0706 19.2577 13.1216 20 11 20C6.0376 20 2 15.9624 2 11C2 6.0376 6.0376 2 11 2C15.9624 2 20 6.0376 20 11ZM4 11C4 14.8599 7.14014 18 11 18C14.8599 18 18 14.8599 18 11C18 7.14014 14.8599 4 11 4C7.14014 4 4 7.14014 4 11Z",
    fill: "currentColor"
  }));
}
export function SearchIconSmall(props) {
  return ___EmotionJSX(SearchIcon, _extends({
    size: "small"
  }, props));
}